<ng-select [(ngModel)]="selectedEnterprises"
           [items]="(enterprises$ | async) ?? []"
           [typeahead]="enterprisesSearchInput$"
           [loading]="enterprisesLoading"
           [placeholder]="placeholder"
           [multiple]="multiple"
           [compareWith]="compareWith"
           [virtualScroll]="false"
           (search)="onSearchTermChange($event)"
           (clear)="resetCurrentSearch()"
           (open)="onDropdownOpen()"
           (close)="onDropdownClose()"
           bindLabel="name"
           class="select-enterprises"
           data-identifier="uid-audit-reports-enterprises">
    <ng-template ng-label-tmp let-item="item" >
        <div (mousedown)="$event.stopPropagation()" [ngClass]="{'span-label':multiple}">
            <span class="ng-value-label">{{ item.name }}</span>
            <span class="close" (click)="onClear(item)" (mousedown)="$event.stopPropagation()" aria-hidden="true" *ngIf="multiple">×</span>
        </div>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
        <div>{{ item.name }}</div>
    </ng-template>
</ng-select>
